module.exports = __webpack_public_path__ + "86ba6c8dab1f05c34011e977ab64a477.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/main/video_placeholder_m.jpg
// module id = 189
// module chunks = 0